import { render, staticRenderFns } from "./KvmPowerMenu.vue?vue&type=template&id=ec904bea&scoped=true&"
import script from "./KvmPowerMenu.vue?vue&type=script&lang=js&"
export * from "./KvmPowerMenu.vue?vue&type=script&lang=js&"
import style0 from "./KvmPowerMenu.vue?vue&type=style&index=0&id=ec904bea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec904bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec904bea')) {
      api.createRecord('ec904bea', component.options)
    } else {
      api.reload('ec904bea', component.options)
    }
    module.hot.accept("./KvmPowerMenu.vue?vue&type=template&id=ec904bea&scoped=true&", function () {
      api.rerender('ec904bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmPowerMenu.vue"
export default component.exports